import { useEffect } from "react"
import { useDispatch } from "react-redux"

import { getFilteredJobCountByStatus } from "../Actions/API/Job/JobActions"
import { APIJobsPerStatusModel } from "../Models/API/APIJobsPerStatusModel"
import { APIJobCountByStatusParams } from "../Models/API/JobModel"
import { hasResult, hasValue } from "../Models/Client/FetchState"
import { MainThunkDispatch } from "../Reducers"
import { JobCountStateKey } from "../Reducers/API/Job/JobReducer"
import { useAppState } from "./useReduxState"

export function useJobCountWithFilters(
    appID: string,
    params: APIJobCountByStatusParams,
    stateKey: JobCountStateKey,
    options?: { refreshInterval?: number }
): APIJobsPerStatusModel | undefined {
    const dispatch = useDispatch<MainThunkDispatch>()
    const count = useAppState(state =>
        state.api.jobs.jobCount[appID]?.get(stateKey)
    )
    const refreshInterval = options?.refreshInterval

    useEffect(() => {
        if (
            !hasResult(count) ||
            (!count.isError && count.value.params !== params)
        ) {
            dispatch(getFilteredJobCountByStatus(appID, stateKey, params))
        }
    }, [appID, dispatch, count, params, stateKey])

    useEffect(() => {
        if (refreshInterval === undefined) {
            return
        }

        const interval = window.setInterval(() => {
            dispatch(getFilteredJobCountByStatus(appID, stateKey, params))
        }, refreshInterval)

        return () => window.clearInterval(interval)
    }, [appID, dispatch, refreshInterval, params, stateKey])

    return hasValue(count) && count.value.params === params
        ? count.value.data
        : undefined
}
